import { Uploader } from 'bricks-ui/packages/bricks-ui';

export default Uploader;
